export default __webpack_public_path__ + "static/media/firstDance2.a2763067.jpg";